<template lang="pug">
  .consultation-output-section
    .location-header.output.pt-5.pb-3(v-if="!isPrint")
      v-row
        v-col.d-flex.justify-space-between(cols="6")
          a.d-flex.align-center.ml-3(:class="panel && panel.length ? 'primary--text' : 'white--text'" @click="panel = []")
            svg-reload(:size="18")
          h4.primary--text.mr-5(v-if="isConcept") Aktuell

        v-col.d-flex(v-if="isConcept" cols="6")
          h4.col-concept-status.primary--text.ml-5 Konzept
          h4.primary--text Kunden-Präferenz

    v-expansion-panels.output-section(v-model="panel" :class="[ showCustomerPref_ && 'show-customer-pref', isVertrag && 'vertrag', isConcept && 'concept' ]" accordion flat tile multiple)
      v-expansion-panel.output-category-panel.mb-3(v-for="c in categories" :key="c.name")
        v-expansion-panel-header.category-header: v-row
          v-col.position-relative(:sm="isConcept ? 6 : 12")
            .d-flex.align-center.print-panel-header
              span {{ c.name }} {{ c.value && isDebugMode ? `(${ c.value })` : '' }}
              svg-warning.svg-right-aligned.ml-5(v-if="c.has_empty && showEmptyNotice" :size="18")
              span.txt-customer-pref(v-if="showCustomerPref_ && isStatus") Kundenpräferenz
            img.traffic-image(v-if="c.value >= 1 && c.value <= 3" :src="getAssetImage(trafficImages[c.value - 1])")

          v-col.position-relative(v-if="isConcept" sm="6")
            img.traffic-image.left-aligned(v-if="c.concept_value >= 1 && c.concept_value <= 3" :src="getAssetImage(trafficImages[c.concept_value - 1])")

        v-expansion-panel-content.pl-3(eager)
          v-row.mt-3
            v-col.output-location(v-for="cl in c.fields.locations" :key="cl.id" cols="12" :sm="isConcept ? 6 : 12")
              h4.primary--text.pt-3.pb-1(v-if="cl.id !== '#'") Standort {{ cl.name }}
              output-category.ml-3(
                :class="cl.id !== '#' ? 'ml-3' : 'mt-3'"
                :fields="cl.fields"
                :buildings="cl.buildings"
                :indent-size="cl.id === '#' ? 0 : 1"
                :print-customer-pref="printCustomerPref"
                :print-vertrag="printVertrag"
                :is-print="isPrint"
                @update="(id, v) => $emit('update', id, v)"
              )

            template(v-if="isConcept")
              template(v-if="!showConceptVertrag"): v-col.output-location(v-for="cl in c.status_fields.locations" :key="`c-${ cl.id }`" cols="12" sm="6")
                h4.primary--text.pt-3.pb-1(v-if="cl.id !== '#'") &nbsp;
                output-category.ml-3(
                  :class="cl.id !== '#' ? 'ml-3' : 'mt-3'"
                  :fields="cl.fields"
                  :buildings="cl.buildings"
                  :indent-size="cl.id === '#' ? 0 : 1"
                  :print-customer-pref="printCustomerPref"
                  :print-vertrag="printVertrag"
                  :is-print="isPrint"
                  is-concept-status
                  @update="(id, v) => $emit('update', id, v)"
                )

              template(v-else): v-col.output-location(v-for="cl in c.vertrag_fields.locations" :key="`c-${ cl.id }`" cols="12" sm="6")
                h4.primary--text.pt-3.pb-1(v-if="cl.id !== '#'") &nbsp;
                output-category.ml-3(
                  :class="cl.id !== '#' ? 'ml-3' : 'mt-3'"
                  :fields="cl.fields"
                  :buildings="cl.buildings"
                  :indent-size="cl.id === '#' ? 0 : 1"
                  :print-customer-pref="printCustomerPref"
                  :print-vertrag="printVertrag"
                  :is-print="isPrint"
                  is-concept-status
                  @update="(id, v) => $emit('update', id, v)"
                )

          v-expansion-panels.flat-panels(:value="getOpenedSubPanels(c.subSections)" flat tile multiple)
            v-expansion-panel.mt-8(
              v-for="(s, i) in c.subSections"
              :key="i"
              :class="showCustomerPref_ && 'has-customer-pref'"
              @change="onTogglePanel(s)"
            )
              // v-row
                v-col(sm="6")
                v-col(sm="6"): .input-customer-pref.concept.pl-3(v-if="s.cust_praef")
                  a
                    svg-radar.primary--text
                  p.font-weight-regular.grey--text.ml-3
                    span.text-pre-wrap {{ s.cust_praef }}
              v-expansion-panel-header.align-start(:class="getHeaderClass(s)"): v-row
                v-col.position-relative(:sm="isConcept ? 6 : 12")
                  h4.primary--text.mb-1 {{ s.name }} {{ s.value && isDebugMode ? `(${ s.value })` : '' }}
                  .debug-info(v-if='isDebugMode') {{ getDebugInfo(s) }}
                  img.traffic-image(v-if="s.value >= 1 && s.value <= 3" :src="getAssetImage(trafficImages[s.value - 1])")

                v-col.position-relative(v-if="isConcept" sm="6")
                  img.traffic-image.left-aligned(v-if="s.concept_value >= 1 && s.concept_value <= 3" :src="getAssetImage(trafficImages[s.concept_value - 1])")
                  //- .consultation--output-category: field-row.concept-field(
                  //-   v-if="s.concept_field"
                  //-   :field="s.concept_field"
                  //-   label-class="ml-4"
                  //- )
                  .input-customer-pref.concept.pl-3(v-if="s.cust_praef")
                    a
                      svg-radar.primary--text
                    p.font-weight-regular.grey--text.ml-3
                      span.text-pre-wrap {{ s.cust_praef }}

              v-expansion-panel-content
                v-row(v-if="showCustomerPref_")
                  v-col.position-relative(cols="12" md="12")
                    v-textarea.input-customer-pref.pt-0(
                      v-if="!isPrint"
                      :value="s.cust_praef"
                      outlined
                      hide-details
                      label="Kundenpräferenz"
                      :class="[showEmptyNotice && !s.cust_praef && 'lime lighten-5']"
                      :readonly="isPrint"
                      :rows="5"
                      @change="(e) => onChangeCustomerPref(s, e)"
                    )

                    p.input-customer-pref.primary--text(v-else-if="s.cust_praef")  {{ s.cust_praef }}

                v-row
                  v-col(cols="12" :sm="isConcept ? 6 : 12")
                    .output-location(v-for="(sl, si) in s.fields.locations" :key="si")
                      h4.primary--text.ml-4.pt-3.pb-1(v-if="sl.id !== '#'") Standort {{ sl.name }}
                      output-category(
                        :class="sl.id === '#' && 'mt-3'"
                        :fields="sl.fields"
                        :buildings="sl.buildings"
                        :indent-size="sl.id === '#' ? 1 : 2"
                        :print-customer-pref="printCustomerPref"
                        :print-vertrag="printVertrag"
                        :is-print="isPrint"
                        @update="(id, v) => $emit('update', id, v)"
                      )

                  template(v-if="isConcept")
                    v-col(v-if="!showConceptVertrag" cols="12" sm="6")
                      .output-location(v-for="(sl, si) in s.status_fields.locations" :key="`c-${ si }`")
                        h4.primary--text.ml-4.pt-3.pb-1(v-if="sl.id !== '#'") &nbsp;
                        output-category(
                          :class="sl.id === '#' && 'mt-3'"
                          :fields="sl.fields"
                          :buildings="sl.buildings"
                          :indent-size="1"
                          :print-customer-pref="printCustomerPref"
                          :print-vertrag="printVertrag"
                          :is-print="isPrint"
                          is-concept-status
                          @update="(id, v) => $emit('update', id, v)"
                        )

                    v-col(v-else cols="12" sm="6")
                      .output-location(v-for="(sl, si) in s.vertrag_fields.locations" :key="`c-${ si }`")
                        h4.primary--text.ml-4.pt-3.pb-1(v-if="sl.id !== '#'") &nbsp;
                        output-category(
                          :class="sl.id === '#' && 'mt-3'"
                          :fields="sl.fields"
                          :buildings="sl.buildings"
                          :indent-size="1"
                          :print-customer-pref="printCustomerPref"
                          :print-vertrag="printVertrag"
                          :is-print="isPrint"
                          is-concept-status
                          @update="(id, v) => $emit('update', id, v)"
                        )

          .output-location
            output-category.mt-3(
              :fields="c.last_fields"
              :indent-size="0"
              :print-customer-pref="printCustomerPref"
              :print-vertrag="printVertrag"
              :is-print="isPrint"
              @update="(id, v) => $emit('update', id, v)"
            )

    slot(name="default")

    v-row.sticky-footer.mt-6
      v-col.pt-0(cols="12"): hr
      v-col.d-flex.flex-column.justify-start(v-if="prevTab" sm="6")
        a.nav-location(@click="$emit('prev-tab')")
          i.fo.fo-arrow-left.primary--text
          span Vorheriger Abschnitt {{ prevTab }}

      v-col.d-flex.flex-column.align-end(v-if="nextTab" sm="6")
        a.nav-location(@click="$emit('next-tab')")
          span Nächster Abschnitt {{ nextTab }}
          i.fo.fo-arrow-right.primary--text

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    // FieldRow: () => import('./field-row'),
    SvgWarning: () => import('@/components/svgs/svg-warning'),
    SvgReload: () => import('@/components/svgs/svg-reload'),
    SvgRadar: () => import('@/components/svgs/svg-radar'),
  },

  watch: {
    isConceptEdit () {
      this.resetGroupElements()
      setTimeout(() => {
        this.alignGroupElements()
      }, 500)
    },

    categories () {
      this.resetGroupElements()
      setTimeout(() => {
        this.alignGroupElements()
      }, 500)
    }
  }
})
export default class OutputSection extends Vue {
  @Prop({ type: Array, default: () => [] }) categories
  @Prop({ type: Boolean, default: false }) isPrint
  @Prop({ type: Boolean, default: false }) printCustomerPref
  @Prop({ type: Boolean, default: false }) printVertrag
  @Prop({ type: String, default: '' }) prevTab
  @Prop({ type: String, default: '' }) nextTab

  panel = [0]
  trafficImages = [
    'light_green.png',
    'light_yellow.png',
    'light_red.png',
  ]

  get showConceptVertrag () {
    return this.isPrint
      ? this.printVertrag
      : this.isConceptEdit
  }

  get showCustomerPref_ () {
    if (!this.isStatus) {
      return false
    }

    return this.isPrint
      ? this.printCustomerPref
      : this.showCustomerPref
  }

  mounted () {
    this.panel = [0]
    this.subPanel = []

    if (this.isPrint) {
      this.panel = this.categories.map((_, i) => i)
    }

    setTimeout(() => {
      this.alignGroupElements()
    }, 500)

    window.addEventListener('resize', this.alignGroupElements)
  }

  getAssetImage (name) {
    return require(`@/assets/images/${ name }`)
  }

  getHeaderClass (section) {
    return !section.fields.fields.length && !section.fields.locations.length
      ? 'hide-expand-icon'
      : ''
  }

  getOpenedSubPanels (subSections) {
    if (this.isPrint) {
      return subSections.map((_, i) => i)
    }

    const panels = []

    subSections.forEach((s, i) => {
      if (this.openSubSections.includes(s.id)) {
        panels.push(i)
      }
    })

    return panels
  }

  onTogglePanel (s) {
    let panels = []
    if (this.openSubSections.includes(s.id)) {
      panels = [
        ...this.openSubSections.filter(s_ => s_ !== s.id)
      ]
    } else {
      panels = [
        ...this.openSubSections,
        s.id
      ]
    }

    this.$store.dispatch('setOpenSubSections', panels)
    // this.resetGroupElements()
    setTimeout(() => {
      this.alignGroupElements()
    }, 500)
  }

  onChangeCustomerPref (field, value) {
    field.cust_praef = value
    this.$emit('input-customer-pref', field.id, value)
  }
}
</script>

<style lang="sass">
.col-concept-status
  flex: 0 0 150px

.output-section
  .traffic-image
    position: absolute
    left: auto
    top: 2px
    right: -6px
    width: 90px
    transform: rotate(180deg)

    &.left-aligned
      right: auto
      left: 34px

  .txt-customer-pref
    position: absolute
    left: calc(66.66% + 6px)

  .flat-panels
    .traffic-image
      top: -6px
      bottom: auto
      left: auto
      right: 0px

      &.left-aligned
        right: auto
        left: 28px

  .v-expansion-panel-header
    h4
      max-width: calc(100% - 100px)

    &.hide-expand-icon
      pointer-events: none

      .v-expansion-panel-header__icon
        display: none

  .category-header
    &.output.v-expansion-panel-header--active
      .traffic-image
        top: 8px

  &.show-customer-pref
    .v-expansion-panel-header
      h4
        max-width: calc(66.66% - 110px)

    .category-header
      .traffic-image
        left: calc(66.66% - 100px)
        right: auto

    .flat-panels
      .traffic-image
        left: calc(66.66% - 106px)
        right: auto

    .consultation--output-category .field-value
      max-width: calc(100% - 16px)

  @media screen and (max-width: 960px)
    .traffic-image
      left: auto !important
      right: 0 !important

    .flat-panels .traffic-image
      left: auto !important
      right: 5px !important

    .input-customer-pref
      position: relative !important
      left: 0 !important
      top: 0px !important
      margin-top: 30px

      .v-label
        display: block !important

    .txt-customer-pref
      display: none
</style>
